import { render, staticRenderFns } from "./DkoDescriptionCard.vue?vue&type=template&id=479c188b"
import script from "./DkoDescriptionCard.vue?vue&type=script&lang=js"
export * from "./DkoDescriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports